import * as React from "react";
import { makeStyles, Typography } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    label: {
      margin: "8px 0"
    }
  };
});
var CustomDialogInputLabel = function CustomDialogInputLabel(_ref) {
  var label = _ref.label;
  var classes = useStyles();
  return /*#__PURE__*/_jsx("div", {
    className: classes.label,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      weight: "medium",
      children: label
    })
  });
};
export default CustomDialogInputLabel;